export class Error {
  isPresent: boolean;
  message: string;
}
